export const onlyNumbers = (str: string) => str.replace(/[^\d]/g, '');
